import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import NavSub from "../components/NavSub";
import { UserContext } from "../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MagnifyingGlass } from "@phosphor-icons/react";
import isGuestUser from "../utils/guestUser";
import ReactDOM from "react-dom";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";

import ToastComponent from "../components/ToastComponent";
import { clientApiUrl, taskApiUrl, reportApiUrl } from "../utils/GetUrl";
import {
  CaretCircleDoubleLeft,
  CaretCircleDoubleRight,
  FileArrowUp,
  FunnelSimple,
} from "phosphor-react";
import "../Styles/DailyVoucherStock.css";
import * as XLSX from "xlsx";

const ReportingActivitySheet = () => {
  const {
    teamsData,
    setTeamsData,
    teamNames,
    setTeamNames,
    usersList,
    fetchTeams,
  } = useContext(UserContext);
  const { token, logout, handleAuthExpiry, userData } = useContext(AuthContext);
  // const [selectedDate, setSelectedDate] = useState('');
  // const [chosenDate, setChosenDate] = useState("");
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (teamNames) {
      setTeams(
        teamNames.filter(
          (team) =>
            team?.superTeamId === 0 && team?.type === "T" && team?.status === true
        )
      );
    }
  }, [teamNames]);

  // const [selectedEmployees, setSelectedEmployees] = useState(usersList);
  const [isAccountResponsibleOpen, setIsAccountResponsibleOpen] = useState();
  const [selectedPrepareName, setSelectedPrepareName] = useState(null);
  const [accSearch, setAccSearch] = useState("");
  const [accountResponsible, setAccountResponsible] = useState([]);
  const [accountResponsible2, setAccountResponsible2] = useState([]);
  const [selectedAccountResponsible, setSelectedAccountResponsible] = useState(
    []
  );
  const dropdownsearchRef = useRef(null);
  const toastRef = useRef(null);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState();
  const [allActivities, setAllActivities] = useState([]);
  const todaysDate = new Date();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // Months are 0-indexed, so +1
  const calendarWrapperRef = useRef(null);
  const [expandedActivities, setExpandedActivities] = useState(true);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [selectedDay, setSelectedDay] = useState(todaysDate.getDate());
  const tableContainerRef = useRef(null);
  const [isTableLoaded, setIsTableLoaded] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const debounceTimeout = useRef(null);

  const handlePreviousYear = () => {
    setSelectedYear((prevYear) => prevYear - 1);
  };

  const handleNextYear = () => {
    setSelectedYear((prevYear) => prevYear + 1);
  };
  const handleMonthChange = (monthIndex) => {
    setSelectedMonth(monthIndex);
    setIsCalendarOpen(false); // Close calendar after month selection
  };
  const fetchSuggestionByText = async () => {
    if (!token) {
      console.error("Token is missing.");
      return;
    }
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllClient?SearchByText=${query}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }
      if (!response.ok) {
        console.error("Failed to fetch suggestions:", response.statusText);
        setLoading(false);
        return;
      }
      const data = await response.json();
      setSuggestions(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (query.length > 0) {
      setLoading(true);

      debounceTimeout.current = setTimeout(() => {
        fetchSuggestionByText();
      }, 1000);
    } else {
      setSuggestions([]);

      setLoading(false);
    }

    return () => {
      clearTimeout(debounceTimeout.current);
    };
  }, [query]);
  const handleCustomersearchClick = () => {
    // return;
    setIsSearchOpen(!isSearchOpen);
  };
  useEffect(() => {
    if (isSearchOpen) {
      window.addEventListener("scroll", handleScroll);
    } else {
      window.removeEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSearchOpen]);
  const handleClearAllSearch = () => {
    setQuery("");
    setPage(1);
    setSelectedSuggestions([]);
  };
  const handleCheckboxChange = (suggestion) => {
    if (selectedSuggestions?.length === 0) {
      setPage(1);
    }
    setSelectedSuggestions((prevSelected) => {
      if (prevSelected?.some((item) => item.Id === suggestion.Id)) {
        return prevSelected?.filter((item) => item.Id !== suggestion.Id);
      } else {
        return [suggestion];
      }
    });
  };
  const handleCheckboxAccountResponsibleChange = (acc) => {
    setSelectedAccountResponsible([acc]);
    setSelectedPrepareName(acc);

    // Don't clear teams here - let the employee filtering handle both cases
    // setSelectedTeams([]); // REMOVE THIS LINE

    // Set selectedEmployees based on both teams AND preparer selection
    if (selectedTeams?.length > 0) {
      // If teams are selected, filter employees by teams AND include the selected preparer
      const teamFilteredEmployees = usersList?.filter((user) =>
        selectedTeams?.includes(parseInt(user?.STM_Team))
      );
      // Ensure the selected preparer is included even if not in selected teams
      const combinedEmployees = [...teamFilteredEmployees];
      if (!teamFilteredEmployees.some((user) => user.EM_ID === acc.EM_ID)) {
        combinedEmployees.push(acc);
      }
      setSelectedEmployees(combinedEmployees);
    } else {
      // If no teams selected, just use the selected preparer
      setSelectedEmployees([acc]);
    }
  };

  useEffect(() => {
    setAccountResponsible(usersList);
    setAccountResponsible2(usersList);
  }, [usersList]);

  const toggleTeamSelector = () => {
    // setTeamSelectorOpen((prev) => !prev);
  };

  const handleAccountingResponsibleClick = () => {
    // setSelectedOption({});
    // setShowOptions(true);
    setIsAccountResponsibleOpen((prevState) => !prevState);
  };

  const handleChange = (event) => {

    if (event.target.value?.[event.target.value?.length - 1] === undefined) {
      setSelectedTeams([]);
      // When clearing teams, maintain the preparer selection if any
      if (selectedPrepareName) {
        setSelectedEmployees([selectedPrepareName]);
      } else {
        setSelectedEmployees(usersList);
      }
      return;
    }

    setSelectedTeams(event.target.value);

    // Update employees based on both teams and preparer
    const teamFilteredEmployees = usersList?.filter((user) =>
      event.target.value?.includes(parseInt(user?.STM_Team))
    );

    if (selectedPrepareName) {
      // Include the selected preparer even if not in selected teams
      const combinedEmployees = [...teamFilteredEmployees];
      if (
        !teamFilteredEmployees.some(
          (user) => user.EM_ID === selectedPrepareName.EM_ID
        )
      ) {
        combinedEmployees.push(selectedPrepareName);
      }
      setSelectedEmployees(combinedEmployees);
    } else {
      setSelectedEmployees(teamFilteredEmployees);
    }
  };
  const clearPreparerSelection = () => {
    setSelectedPrepareName(null);
    setSelectedAccountResponsible([]);
    // Reset employees based on teams selection
    if (selectedTeams?.length) {
      const filteredEmployees = usersList?.filter((user) =>
        selectedTeams?.includes(parseInt(user?.STM_Team))
      );
      setSelectedEmployees(filteredEmployees);
    } else {
      setSelectedEmployees(usersList);
    }
  };

  const handleClearAll = (event) => {
    event.preventDefault();
    setSelectedTeams([]);
    // Reset to all users or just the preparer if one is selected
    if (selectedPrepareName) {
      setSelectedEmployees([selectedPrepareName]);
    } else {
      setSelectedEmployees(usersList);
    }
  };
  useEffect(() => {
    if (!selectedTeams?.length) {
      if (selectedPrepareName) {
        setSelectedEmployees([selectedPrepareName]);
      } else {
        setSelectedEmployees(usersList);
      }
    } else {
      const filteredEmployees = usersList?.filter((user) =>
        selectedTeams?.includes(parseInt(user?.STM_Team))
      );

      // Include selected preparer if one exists and not already in filtered list
      if (
        selectedPrepareName &&
        !filteredEmployees.some(
          (user) => user.EM_ID === selectedPrepareName.EM_ID
        )
      ) {
        setSelectedEmployees([...filteredEmployees, selectedPrepareName]);
      } else {
        setSelectedEmployees(filteredEmployees);
      }
    }
  }, [selectedTeams, usersList, token, selectedPrepareName]);

  useEffect(() => {
    const filteredEmployees = usersList?.filter((user) =>
      selectedTeams?.includes(parseInt(user?.STM_Team))
    );
    setSelectedEmployees(filteredEmployees);

  }, [selectedTeams, usersList, token]);

  const fetchAllActivities = async () => {
    try {
      // setLoadingActivities(true); //
      const response = await fetch(
        `${clientApiUrl}/GetAllActivity?Page=1&ItemsPerPage=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }
      if (response.ok) {
        const data = await response.json();

        setAllActivities(
          data?.filter(
            (act) =>
              (act?.AL_Type === "Reporting Activites" ||
                act?.AL_Type === "Adhoc") &&
              act?.AL_Status === "1"
          )
        );
        return data;
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoadingActivities(false); // End loading
    }
  };

  useEffect(() => {
    if (token) {
      fetchAllActivities();
    }
  }, [token]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    const handleScroll = () => {
      setIsSearchOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsAccountResponsibleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownsearchRef]);

  const [expanded, setExpanded] = useState(true);

  //fetching data
  const [page, setPage] = useState(1);
  const [masterData, setMasterData] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [end, setEnd] = useState(false);
  // const [isTableLoaded, setIsTableLoaded] = useState(false);
  const fetchInProgress = useRef(false); //

  const formatSelectedEmployees = (selected) => {
    const emIds = selected?.map((item) => `'${item["EM_ID"]}'`);
    return emIds?.join(",");
  };
  useEffect(() => {
    // formatSelectedEmployees(selectedEmployees);
  }, [selectedEmployees, selectedTeams, token]);

  const fetchCustomer = async (dateStart, dateEnd, first) => {
    const clientId = selectedSuggestions?.[0]?.Id;
    if (!allActivities?.length) return;
    if (loading || fetchInProgress.current) return;
    fetchInProgress.current = true; // Set the flag to true
    setLoading(true);

    const date = formatDate(selectedDay, selectedMonth, selectedYear);

    try {
      setIsTableLoaded(false);
      const response = await fetch(
        `${clientApiUrl}/GetAllClient?Page=${first ? 1 : page}&ItemsPerPage=${
          clientId ? 1 : 200
        }&CreatDate=${date}${
          clientId
            ? `&id=${clientId}`
            : selectedEmployees.length > 0 || selectedPrepareName
            ? `&SubOwnerEMIDs=${formatSelectedEmployees(selectedEmployees)}`
            : ""
        }`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        if (data.length === 0) {
          setEnd(true);
        } else {
          const formattedIds = data.map((d) => `'${d?.Id}'`).join(", ");
          await fetchedReportsAndTasks(data, formattedIds, dateStart, dateEnd);
        }
      } else {
        setLoading(false);
        setEnd(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      fetchInProgress.current = false; // Reset the flag
    }
  };

  const fetchedReportsAndTasks = async (
    clientData,
    ids,
    dateStart,
    dateEnd
  ) => {
    if (!ids || !dateStart || !dateEnd) return;
    const startOfMonth = `${selectedYear}-${String(selectedMonth).padStart(
      2,
      "0"
    )}-01`;
    const endOfMonthDate = new Date(selectedYear, selectedMonth, 0);
    const endOfMonth = `${endOfMonthDate.getFullYear()}-${String(
      endOfMonthDate.getMonth() + 1
    ).padStart(2, "0")}-${String(endOfMonthDate.getDate()).padStart(2, "0")}`;

    try {
      const reportsResponse = await fetch(
        `${reportApiUrl}/GetReports?ClientId=${ids}&DteRange1=${startOfMonth}&DteRange2=${endOfMonth}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (reportsResponse.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(reportsResponse);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      let reportsData = [];
      if (reportsResponse.ok) {
        reportsData = await reportsResponse.json();
      }

      const tasksResponse = await fetch(
        `${taskApiUrl}/GetTaskTotalTime?DateRange1=${startOfMonth}&DateRange2=${endOfMonth}&clientId=${ids}&ActivtyType=Reporting Activities`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (tasksResponse.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError2 = handleAuthExpiry(tasksResponse);
      if (handleAuthError2 === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      let tasksData = [];
      if (tasksResponse.ok) {
        tasksData = await tasksResponse.json();
      }

      const currentMergedData = clientData.map((client) => {
        const taskDataForClient = allActivities.map((activity) => {
          const matchingTask = tasksData.find(
            (task) =>
              task.ActivityId === activity.AL_ID && task.ClientId === client.Id
          );

          return (
            matchingTask || {
              TotalTime: "0.00",
              ActivityId: activity.AL_ID,
              CreateDate: "",
              ClientId: client.Id,
              TaskStatus: "P",
            }
          );
        });

        const matchingReport = reportsData.find(
          (report) => report.ClientId === client.Id
        );

        const defaultReportFields = {
          Id: null,
          ReceivedVolume: "",
          PendingVolume: "",
          Volume2: "",
          CommentOfVolume: "",
          PaymentCheck: "",
          PaymentStatus: "",
          CommentOfPaymentFaild: "",
          ReportType: "",
          ReceivedDate: "",
          DueDate: "",
          DateOfSubmission: "",
          ClientId: client.Id,
          CreatedBy: "",
          SynergyPreparer: "",
          CreateDate: "",
        };

        return {
          ...client,
          ...(matchingReport || defaultReportFields),
          tasks: taskDataForClient,
        };
      });

      setMergedData((prev) => [...prev, ...currentMergedData]);
      setIsTableLoaded(true);
    } catch (error) {
      console.error("Error fetching reports or tasks:", error);
    }
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const isInitialRender = useRef(true);

  useEffect(() => {
    const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
    const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);
    fetchCustomer(dateStart, dateEnd, false);
  }, [page, allActivities]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    setEnd(false);
    setPage(1);
    setMergedData([]);
    setMasterData([]);
    // new Promise(resolve => setTimeout(resolve, 2000));

    const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
    const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);
    fetchCustomer(dateStart, dateEnd, true);
  }, [
    selectedDay,
    selectedMonth,
    selectedYear,
    selectedEmployees,
    selectedSuggestions,
  ]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const formatDate = (day, month, year) => {
    const formattedMonth = String(month).padStart(2, "0"); // Ensure two-digit month
    const formattedDay = String(day).padStart(2, "0"); // Ensure two-digit day if needed
    return `${year}-${formattedMonth}-${formattedDay || "01"}`;
  };

  const getUserFirstName = (emId) => {
    const user = usersList?.find((user) => user.EM_ID === emId);
    return user ? user.EM_FirstName + " " + user.EM_LastName : "";
  };

  const debounceRef = useRef(null); // A ref to hold the debounce timeout

  const [isDownloading, setIsDownloading] = React.useState(false);
  const handleDownload = async () => {
    const startOfMonth = `${selectedYear}-${String(selectedMonth).padStart(
      2,
      "0"
    )}-01`;
    const endOfMonthDate = new Date(selectedYear, selectedMonth, 0);
    const endOfMonth = `${endOfMonthDate.getFullYear()}-${String(
      endOfMonthDate.getMonth() + 1
    ).padStart(2, "0")}-${String(endOfMonthDate.getDate()).padStart(2, "0")}`;

    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User Does not have Add or Edit Access`);
      return;
    }

    // Get selected team names
    const selectedTeamNames = selectedTeams
      .map((teamId) => {
        const team = teams.find((team) => team.id === teamId);
        return team?.name;
      })
      .filter(Boolean) // Remove any undefined/null values
      .join(", ");

    // Get preparer name
    const preparerName = selectedPrepareName
      ? `${selectedPrepareName.EM_FirstName} ${selectedPrepareName.EM_LastName}`
      : "";

    try {
      setIsDownloading(true); // start spinner
      const response = await fetch(`${reportApiUrl}/GetReportFile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          DateRange1: startOfMonth,
          DateRange2: endOfMonth,
          ReportType: "Reporting Activities",
          TeamName: selectedTeamNames,
          PreparerName: preparerName,
        }),
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      const result = await response.json();
      if (result.Status) {
        const fileUrl = result.Result.URI;
        window.location.href = fileUrl;
      } else {
        console.error("Error in fetching report:", result);
      }
    } catch (error) {
      console.error("Error in fetch:", error);
    } finally {
      setIsDownloading(false); // stop spinner
    }
  };
  // Inline spinner style
  const spinnerStyle = {
    width: "14px",
    height: "14px",
    border: "2px solid #ccc",
    borderTop: "2px solid #3d025f",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  };

  // Inject keyframes for animation (only once)
  React.useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const calculateProgression = (data) => {
    // Count of "Completed" (C) tasks
    const completedTasks = data?.tasks?.filter(
      (task) => task?.TaskStatus === "C"
    )?.length;
    const notApplicableTasks = data?.tasks?.filter(
      (task) => task?.TaskStatus === "A"
    )?.length;
    const totalActivities = data?.tasks?.length;
    const progression =
      totalActivities > 0
        ? ((completedTasks + notApplicableTasks) / totalActivities) * 100
        : 0;

    return `${progression.toFixed(2)}%`; // Return the percentage formatted with 2 decimal places
  };
  const handleScroll = useCallback(() => {
    const container = tableContainerRef.current;
    if (!container || loading || end) return;

    // Calculate distance from bottom
    const { scrollTop, scrollHeight, clientHeight } = container;
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    // Load more when within 200px of bottom
    if (distanceFromBottom < 200) {
      setPage((prevPage) => prevPage + 1);
    }
  }, [loading, end]);

  // Add debounce

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);
  const calculateFinalStatus = (data) => {
    const progression = parseFloat(calculateProgression(data).replace("%", ""));
    return progression === 100 ? "Completed" : "Not Completed";
  };

  const getUserTeamName = (emId) => {
    const user = usersList?.find((user) => user.EM_ID === emId);
    return user
      ? teamNames?.find((team) => team.id === parseFloat(user.STM_Team))
          ?.name || null
      : null; // Return null instead of "Unknown Team"
  };

  const filteredData = mergedData.filter((data) => {
    const teamName = getUserTeamName(data?.SubOwner);
    return teamName !== null; // Only include entries with a valid team name
  });

  useEffect(() => {
  }, [allActivities]);

  useEffect(() => {
    const tableContainer = document.querySelector(".table-container");

    if (tableContainer) {
      let isDown = false;
      let startX;
      let scrollLeft;

      const handleMouseDown = (e) => {
        isDown = true;
        tableContainer.classList.add("active");
        startX = e.pageX - tableContainer.offsetLeft;
        scrollLeft = tableContainer.scrollLeft;
      };

      const handleMouseLeave = () => {
        isDown = false;
        tableContainer.classList.remove("active");
      };

      const handleMouseUp = () => {
        isDown = false;
        tableContainer.classList.remove("active");
      };

      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tableContainer.offsetLeft;
        const walk = (x - startX) * 2; // Adjust multiplier for speed
        tableContainer.scrollLeft = scrollLeft - walk;
      };

      tableContainer.addEventListener("mousedown", handleMouseDown);
      tableContainer.addEventListener("mouseleave", handleMouseLeave);
      tableContainer.addEventListener("mouseup", handleMouseUp);
      tableContainer.addEventListener("mousemove", handleMouseMove);

      return () => {
        tableContainer.removeEventListener("mousedown", handleMouseDown);
        tableContainer.removeEventListener("mouseleave", handleMouseLeave);
        tableContainer.removeEventListener("mouseup", handleMouseUp);
        tableContainer.removeEventListener("mousemove", handleMouseMove);
      };
    }
  }, []);
  return (
    <div>
      <NavSub />
      <ToastComponent ref={toastRef} timeout={4000} />

      <div
        style={{
          display: "flex",
          gap: "28px",
          padding: "20px 24px",
          width: "98%",
          margin: "1rem auto",
          background: "white",
          borderRadius: "10px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "28px" }}>
          <FormControl className="select-dropdown-user">
            <InputLabel
              id="team-selector-label"
              className="select-dropdown-label"
              shrink={false}
              onClick={toggleTeamSelector}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }} // Ensures clickable area
            >
              Select Teams
            </InputLabel>

            <Select
              labelId="team-selector-label"
              id="team-selector"
              multiple
              value={selectedTeams}
              onChange={handleChange}
              disabled={selectedPrepareName}
              renderValue={(selected) =>
                selected
                  .map((teamId) => {
                    const team = teams.find((team) => team.id === teamId);
                    return team?.Name;
                  })
                  .join(" ")
              }
              style={{ width: "150px" }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250,
                  },
                },
              }}
            >
              {selectedTeams?.length > 0 && (
                <MenuItem onClick={(e) => handleClearAll(e)}>
                  <ListItemText
                    style={{ color: "red" }}
                    primary={"Clear All"}
                  />
                </MenuItem>
              )}
              {teams.map((team) => (
                <MenuItem key={team.id} value={team.id}>
                  <Checkbox checked={selectedTeams.indexOf(team.id) > -1} />
                  <ListItemText primary={team.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div
            className="Title-STR-main2"
            onClick={(e) => {
              if (selectedTeams.length === 0) {
                handleAccountingResponsibleClick();
              } else {
                e.stopPropagation(); // prevent opening when disabled
              }
            }}
            style={{
              pointerEvents: selectedTeams.length > 0 ? "none" : "auto",
              opacity: selectedTeams.length > 0 ? 0.5 : 1,
              cursor: selectedTeams.length > 0 ? "not-allowed" : "pointer",
            }}
          >
            {selectedPrepareName?.EM_FirstName +
              selectedPrepareName?.EM_LastName || "Preparer Name"}
            <FontAwesomeIcon
              className="str-caret-icon"
              icon={isAccountResponsibleOpen ? faCaretUp : faCaretDown}
            />
            {isAccountResponsibleOpen && (
              <div ref={dropdownsearchRef} className="search-drop-DailyVoucher">
                <div className="search-drop-page">
                  <div className="main-suggestion">
                    <div className="input-suggestion">
                      <div className="icon-search-phospher">
                        <MagnifyingGlass
                          size={20}
                          color="#ada4a4"
                          weight="fill"
                        />
                      </div>
                      <input
                        type="text"
                        value={accSearch}
                        className="input-suggestion-search"
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const value = e.target.value.toLowerCase();
                          setAccSearch(value);
                          setAccountResponsible2(
                            accountResponsible?.filter((acc) =>
                              (acc.EM_FirstName + " " + acc?.EM_LastName)
                                .toLowerCase()
                                .includes(value)
                            )
                          );
                        }}
                        placeholder="Start typing..."
                      />
                    </div>
                    <div tabIndex={1}>
                      <div
                        style={{ color: "#B00000", padding: "2px 22px" }}
                        onClick={clearPreparerSelection}
                      >
                        Clear Preparer
                      </div>
                      {accountResponsible2?.map((acc) => (
                        <div key={acc.EM_ID} className="suggestion-list-li">
                          <input
                            type="radio"
                            className="radio-searchbox"
                            style={{
                              accentColor: "rgb(80, 20, 90)",
                              width: "18px",
                              height: "18px",
                            }}
                            checked={selectedAccountResponsible?.some(
                              (item) => item.EM_ID === acc?.EM_ID // Compare using EM_ID for uniqueness
                            )}
                            onChange={() =>
                              handleCheckboxAccountResponsibleChange(acc)
                            }
                          />
                          <label className="li-content">
                            {acc.EM_FirstName + " " + acc.EM_LastName}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "24px" }}
        >
          <div className="calendar-picker" ref={calendarWrapperRef}>
            <button onClick={toggleCalendar} className="calendar-button">
              {`${months[selectedMonth - 1]} ${selectedYear}`}
            </button>
            {isCalendarOpen && (
              <div
                className="calendar-dropdown"
                style={{
                  zIndex: 1000, // Higher than table headers (which are at zIndex: 10)
                }}
              >
                <div className="year-selector">
                  <button onClick={handlePreviousYear} className="year-nav">
                    &lt;
                  </button>
                  <span className="year-display">{selectedYear}</span>
                  <button onClick={handleNextYear} className="year-nav">
                    &gt;
                  </button>
                </div>

                <div className="month-grid">
                  {months.map((month, index) => (
                    <div
                      key={index}
                      className={`month-item ${
                        index + 1 === selectedMonth ? "selected" : ""
                      }`}
                      onClick={() => handleMonthChange(index + 1)}
                    >
                      {month}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div
            className="Nav-btn-user"
            onClick={!isDownloading ? handleDownload : null}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: isDownloading ? "not-allowed" : "pointer",
            }}
          >
            {isDownloading ? (
              <>
                <div style={spinnerStyle}></div>
                <button
                  className="Nav-Sub-btn"
                  style={{ opacity: 0.6 }}
                  disabled
                >
                  DOWNLOADING...
                </button>
              </>
            ) : (
              <>
                <FileArrowUp size={25} color="#3d025f" weight="fill" />
                <button className="Nav-Sub-btn">DOWNLOAD FILES</button>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          width: "98%",
          margin: "1rem auto",
          height: "calc(100vh - 250px)", // Fixed height (adjust as needed)
          overflow: "auto",
          position: "relative",
          scrollbarWidth: "auto", // For Firefox
          scrollbarColor: "#888 transparent", // For Firefox
          // WebKit scrollbar styling
          "&::-webkit-scrollbar": {
            width: "16px", // Horizontal scrollbar height
            height: "16px", // Vertical scrollbar width
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "6px",
          },
        }}
        className="table-container"
        ref={tableContainerRef} // Add this ref
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            position: "relative",
          }}
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "white",
            }}
          >
            <tr>
              <th
                className="header-customername"
                style={{
                  position: "sticky",
                  left: 0,
                  top: 0,
                  zIndex: 20,
                }}
              >
                <div
                  style={{
                    display: "flex",

                    gap: "16px",
                    alignItems: "center",
                  }}
                >
                  Customer Name
                  <FunnelSimple
                    className="icon-search-dropdown"
                    onClick={handleCustomersearchClick}
                    weight="bold"
                    size={20}
                    color="#061347"
                  />
                </div>
                {isSearchOpen &&
                  ReactDOM.createPortal(
                    <div
                      ref={dropdownsearchRef}
                      className="search-drop-design-report"
                      style={{
                        position: "fixed", // fixed so it floats relative to viewport
                        top: "260px", // adjust to align under header
                        left: "30px", // adjust to align with funnel icon
                        background: "white",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        zIndex: 9999, // stays on top of sticky headers
                      }}
                    >
                      <div className="search-drop-page">
                        <div className="main-suggestion">
                          <div className="input-suggestion">
                            <div className="icon-search-phospher">
                              <MagnifyingGlass
                                size={20}
                                color="#ada4a4"
                                weight="fill"
                              />
                            </div>

                            <input
                              type="text"
                              value={query}
                              className="input-suggestion-search"
                              onChange={(e) => setQuery(e.target.value)}
                              placeholder="Start typing..."
                            />

                            <button
                              className="clear-title"
                              onClick={handleClearAllSearch}
                            >
                              Clear All
                            </button>
                          </div>

                          {searchLoading ? (
                            <p className="suggestion-title">
                              <CircularProgress
                                width={30}
                                style={{ color: "purple" }}
                              />
                            </p>
                          ) : (
                            <div style={{ maxHeight: "500px" }} tabIndex={1}>
                              {suggestions.map((suggestion) => (
                                <div
                                  key={suggestion.Id}
                                  className="suggestion-list-li"
                                >
                                  <input
                                    type="checkbox"
                                    className="check-searchbox"
                                    checked={selectedSuggestions.some(
                                      (item) => item.Id === suggestion.Id
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(suggestion)
                                    }
                                  />
                                  <label className="li-content">
                                    {suggestion.Name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>,
                    document.body
                  )}
              </th>
              <th
                style={{
                  backgroundColor: "#D9D9D9",
                  color: "#000",
                  minWidth: "200px",
                  textAlign: "start",
                  position: "sticky",
                  top: 0, // stick to top
                  left: 300, // push right after Customer Name (adjust to match Customer Name width)
                  zIndex: 19, // slightly below Customer Name (which has zIndex: 20)
                }}
              >
                {" "}
                Project Number
                <span
                  style={{
                    position: "absolute",
                    minWidth: "150px",
                    right: "-115px",
                    top: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setExpanded(!expanded)}
                >
                  {" "}
                  {expanded ? (
                    <CaretCircleDoubleRight size={32} color="#080808" />
                  ) : (
                    <CaretCircleDoubleLeft size={32} color="#080808" />
                  )}
                </span>
              </th>
              {expanded && (
                <th
                  style={{
                    backgroundColor: "#fff",
                    padding: "15px",
                    minWidth: "150px",
                    position: "sticky",
                    top: -23,
                    zIndex: 10,
                  }}
                >
                  ERP System
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Cost Center
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department Head{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Account Owner
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Team Lead{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Accounting responsible
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Quality Consultant{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Process Lead
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Department Lead
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Synergy Team
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    padding: "15px",
                    fontFamily: "Poppins",
                    position: "sticky",
                    top: -23,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Frequency Report Customer
                  <span
                    style={{
                      position: "absolute",
                      minWidth: "150px",
                      right: "-120px",
                      top: "20px",
                      color: "black",
                      cursor: "pointer",
                    }}
                    onClick={() => setExpandedActivities(!expandedActivities)}
                  >
                    {expandedActivities ? (
                      <CaretCircleDoubleRight size={32} color="#080808" />
                    ) : (
                      <CaretCircleDoubleLeft size={32} color="#080808" />
                    )}
                  </span>
                </th>
              )}

              {expandedActivities &&
                allActivities?.map((act) => {
                  return (
                    <th
                      className="Expand-styles"
                      style={{
                        minWidth: "330px",
                        padding: "15px",
                        position: "sticky",
                        top: -23,
                        background: "white",
                        zIndex: 10,
                      }}
                      key={act.AL_ID}
                    >
                      {act.AL_Name}
                    </th>
                  );
                })}

              <th
                className="last-portion-style"
                style={{ position: "sticky", top: -23, zIndex: 10 }}
              >
                Prepare Progress
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: -23, zIndex: 10 }}
              >
                Final Status
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((data, index) => {
              return (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                    position: "relative", // Add this for proper positioning context
                  }}
                >
                  <td
                    style={{
                      padding: "15px",
                      fontFamily: "Poppins",
                      background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                      position: "sticky",
                      left: 0,
                      top: 65,

                      zIndex: 15,
                    }}
                  >
                    {data?.Name}
                  </td>
                  <td
                    style={{
                      padding: "15px",
                      fontFamily: "Poppins",
                      background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                      position: "sticky",
                      left: 300, // same offset as header
                      top: 65,
                      zIndex: 14, // below header
                    }}
                  >
                    {data?.ProjectNumber}
                  </td>
                  {expanded && (
                    <>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {data?.ERPSystem}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {selectedSuggestions?.length > 0
                          ? data?.CostCenterName
                          : data?.CostCenter}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {selectedSuggestions?.length > 0
                          ? data?.DepartmentName
                          : data?.Department}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {data?.HODName}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {data?.OwnerEMId}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {data?.LeadId}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {getUserFirstName(data?.SubOwner)}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {getUserFirstName(data?.SubQC)}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {" "}
                        {getUserFirstName(data?.SubProcLead)}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {getUserFirstName(data?.SubProcLead)}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {" "}
                        {getUserTeamName(data?.SubOwner)}
                      </td>
                      <td style={{ padding: "15px", fontFamily: "Poppins" }}>
                        {" "}
                        {data?.ReportingFrequencyName}
                      </td>
                    </>
                  )}

                  {expandedActivities &&
                    (data?.tasks || allActivities).map((act) => {
                      const statusDisplay =
                        act?.TaskStatus === "C"
                          ? "Completed"
                          : act?.TaskStatus === "A"
                          ? "Applicable"
                          : act?.TaskStatus === "R"
                          ? "Not Completed"
                          : act?.TaskStatus === "P"
                          ? "Pending"
                          : "Pending";

                      const statusColor =
                        act?.TaskStatus === "C"
                          ? "#007F40"
                          : act?.TaskStatus === "P"
                          ? "gray"
                          : act?.TaskStatus === "A"
                          ? "darkgray"
                          : act?.TaskStatus === "R"
                          ? "#B00000"
                          : "black";

                      return (
                        <td
                          key={act?.ActivityId}
                          style={{
                            minWidth: "250px",
                            textAlign: "start",
                            padding: "15px",
                            color: statusColor,
                          }}
                        >
                          {statusDisplay}
                        </td>
                      );
                    })}

                  <th
                    className="last-portion-style"
                    style={{
                      backgroundColor: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                      padding: "15px",
                    }}
                  >
                    {calculateProgression(data)}
                  </th>
                  <th
                    className="last-portion-style"
                    style={{
                      backgroundColor: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                      padding: "15px",
                    }}
                  >
                    {calculateFinalStatus(data)}
                  </th>
                </tr>
              );
            })}
          </tbody>
        </table>
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        )}
        {end && <div>No more Data...</div>}
      </div>
    </div>
  );
};

export default ReportingActivitySheet;
